// extracted by mini-css-extract-plugin
export default {"container":"cf9_qBwXL","checkmark":"c8bgjWPaY","transparent":"ccWYUU4_L"};